export function isAppSwitch({
  url,
  apiProjectId,
  projectId,
}: {
  url: URL | string;
  apiProjectId?: string;
  projectId?: string;
}) {
  if (apiProjectId) {
    return apiProjectId !== projectId;
  }

  let urlObject: URL;

  if (typeof url === 'string') {
    urlObject = new URL(url, window.location.origin);
  } else {
    urlObject = url;
  }

  return urlObject.hostname !== window.location.hostname;
}
